module.exports = __webpack_public_path__ + "img/icn_eraser.7e1ea8c5.svg";